import styled from 'styled-components'
import { Styles as QuizStyles } from '~/pages/anatomy/libs/singleChoiceStyles'
import { BREAKPOINTS } from '~/shared/constants/uiConstants'

const STATEMENT_BG_COLOR = '#e7e9f6'

export const Styles = {
  LocalRoot: styled(QuizStyles.Root)`
    display: flex;
    flex-direction: column;
  `,

  LocalContainer: styled(QuizStyles.StyledContainer)`
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    padding-bottom: 0;
    gap: 16px;
  `,

  StatementContainer: styled(QuizStyles.StatementContainer)`
    background-color: ${STATEMENT_BG_COLOR};
  `,

  Statement: styled(QuizStyles.Statement)`
    font-size: 14px;
  `,

  StickyBottom: styled.div<{ $hasAnswer: boolean }>`
    width: 100%;
    background: ${({ $hasAnswer }) => ($hasAnswer ? '#DAECB6' : 'transparent')};
    border-radius: 16px 16px 0 0;
  `,

  StickyBottomInner: styled.div`
    max-width: ${BREAKPOINTS[375]}px;
    margin: 0 auto;
    padding: 16px 16px 24px;
    display: flex;
    flex-direction: column;
    gap: 30px;
  `,

  InfoText: styled.p`
    font-size: 15px;
    line-height: 1.1;
    font-weight: 600;
    color: #000;
  `,
} as const
